import { Link } from "react-router-dom";
import { articlesByDate } from "../articles";
import { useDocumentMeta } from "../lib/useDocumentMeta";
import { toDocumentMeta, getRouteMeta } from "../route-meta";
import { rolloutMode } from "../rollout";

export default function Articles() {
  useDocumentMeta(toDocumentMeta(getRouteMeta("/articles", rolloutMode)!));
  return (
    <>
      <section className="mk-container pt-12 sm:pt-20 pb-6">
        <p className="mk-eyebrow">Articles</p>
        <h1 className="mk-h1 mt-4 max-w-3xl">Running, training and recovery.</h1>
        <p className="mk-lead mt-5 max-w-3xl">
          Read about long-run distance, training intensity, recovery and tapering, with
          explanations of the studies and examples for your training.
        </p>
      </section>

      <section className="mk-container py-10">
        <ul className="grid gap-4 md:grid-cols-2">
          {articlesByDate.map((a) => (
            <li key={a.meta.slug}>
              <Link
                to={`/articles/${a.meta.slug}`}
                className="block mk-card hover:border-px-green-dark/40 transition"
              >
                <div className="flex items-center justify-between">
                  <p className="mk-eyebrow">{a.meta.eyebrow}</p>
                  <span className="text-[11px] text-px-text-muted">
                    {a.meta.readMinutes} min read
                  </span>
                </div>
                <h2 className="mk-h3 mt-3">{a.meta.title}</h2>
                <p className="mt-3 text-sm text-px-text-soft leading-relaxed">
                  {a.meta.description}
                </p>
                <p className="mt-4 text-sm font-semibold text-px-green-dark">Read →</p>
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </>
  );
}
